// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"7400":"af741f629e7374fc","9771":"53e2a3b31477ca62"}[chunkId] + ".css";
};